<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>for O. H.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?042fedb9